import { Link } from 'react-router-dom';

import MicrosoftOverview from '../components/cloudPrep/microSoft/MicrosoftOverview';

const MicrosoftAIOverviewPage = () => {
  return (
    <div>
      <MicrosoftOverview
        linkTo='https://learn.microsoft.com/en-us/credentials/certifications/azure-ai-fundamentals/?practice-assessment-type=certification'
        lastUpdated='05/02/2025'
        role='AI Engineer'
        isAIOverview={true}
        title='Azure AI Fundamentals'
        description='Demonstrate fundamental AI concepts related to the development of software and services of Microsoft Azure to create AI solutions.'
      >
        <div className='space-y-6 text-gray-700'>
          <p className='text-base leading-relaxed'>
            This certification is an opportunity for you to demonstrate
            knowledge of machine learning and AI concepts and related Microsoft
            Azure services. As a candidate for this certification, you should
            have familiarity with the self-paced or instructor-led learning
            material.
          </p>

          <p className='text-base leading-relaxed'>
            This certification is intended for you if you have both technical
            and non-technical backgrounds. Data science and software engineering
            experience are not required. However, you would benefit from having
            awareness of:
          </p>

          <ul className='ml-4 list-inside list-disc space-y-2'>
            <li>Basic cloud concepts</li>
            <li>Client-server applications</li>
          </ul>

          <p className='text-base leading-relaxed'>
            You can use Azure AI Fundamentals to prepare for other Azure
            role-based certifications like Azure Data Scientist Associate or
            Azure AI Engineer Associate, but it’s not a prerequisite for any of
            them.
          </p>

          <p className='text-base leading-relaxed'>
            You may be eligible for ACE college credit if you pass this
            certification. See{' '}
            <Link
              target='_blank'
              to='https://learn.microsoft.com/en-us/credentials/certifications/college-credit'
              className='text-blue-600 hover:text-blue-800 hover:underline'
            >
              ACE college credit for certification exams
            </Link>{' '}
            for details.
          </p>
        </div>
      </MicrosoftOverview>
    </div>
  );
};

export default MicrosoftAIOverviewPage;
